import { setCandidateMiddleware } from './candidates';

export default {
  setCandidateMiddleware,
};
